import React, { useState } from 'react';

const Search = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!onSearch) {
            return;
        }
        onSearch(searchTerm.trim());
    };

    return (
        <div className="search mb-4">
            <h5 className="mb-3">MOT-CLÉ</h5>
            <form className="input-group" onSubmit={handleSubmit}>
                <input
                    type="text"
                    value={searchTerm}
                    onChange={(event) => setSearchTerm(event.target.value)}
                    className="form-control"
                    placeholder="Recherchez vos mots-clés..."
                    aria-label="Rechercher"
                />
                <button className="btn" type="submit" title="Rechercher">
                    <i className="fa-light fa-magnifying-glass"></i>
                </button>
            </form>
        </div>
    );
};

export default Search;
